import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Esto reemplaza a mi médico?',
    answer: 'No, lo potencia al bajar tus niveles de cortisol y estrés sistémico.'
  }, {
    question: '¿Qué pasa si no conozco mi historia familiar?',
    answer: 'El método incluye ejercicios para trabajar con lo que tu cuerpo "sabe", incluso si no tienes datos de tus abuelos.'
  }, {
    question: '¿Es un contenido religioso?',
    answer: 'Tiene una base de fe profunda en Dios y la vida, pero respeta cualquier camino espiritual.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Es un acceso inmediato al PDF y los audios tras tu compra.'
  }];
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-cream py-10 md:py-16 px-6" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-22">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brown mb-8 text-center" data-id="element-23">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-3" data-id="element-24">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-2xl shadow-sm border border-rose/10 overflow-hidden" data-id="element-25">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-cream/30 transition-colors" data-id="element-26">
                  <h3 className="font-sans text-lg font-semibold text-brown pr-4" data-id="element-27">
                    {faq.question}
                  </h3>
                  <ChevronDownIcon className={`w-6 h-6 text-rose flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-28" />
                </button>

                <motion.div initial={false} animate={{
              height: openIndex === index ? 'auto' : 0,
              opacity: openIndex === index ? 1 : 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-29">
                  <p className="font-sans text-base text-brown/80 leading-relaxed px-6 pb-6" data-id="element-30">
                    {faq.answer}
                  </p>
                </motion.div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}